import { EmptyArray } from 'lib/array/arrayUtils'
import { createSelector } from 'reselect'
import getIsCheckoutLoyaltyInternationalTrip from './getIsCheckoutLoyaltyInternationalTrip'
import getIsCurrentRegionUserLoyaltyRegion from 'loyalty/selectors/getIsCurrentRegionUserLoyaltyRegion'
import { findPostPurchaseCheckout } from 'lib/checkout/checkoutUtils'
import getIsTasteOfGoldEligibleCheckout from './getIsTasteOfGoldEligibleCheckout'

const getCanRedeemTransferLoyaltyBenefit = createSelector(
  (state: App.State) => state.loyalty.account.data?.benefits,
  (state: App.State) => getIsCheckoutLoyaltyInternationalTrip(state),
  (state: App.State) => state.loyalty.config?.transferAirports,
  (state: App.State) => getIsCurrentRegionUserLoyaltyRegion(state),
  (state: App.State) => findPostPurchaseCheckout(state.checkout.cart.mode),
  (state: App.State) => getIsTasteOfGoldEligibleCheckout(state),
  (
    userBenefits,
    isInternationalTrip,
    airportCodes = EmptyArray,
    isCurrentRegionUserLoyaltyRegion,
    postPurchase,
    isTasteOfGoldEligibleCheckout,
  ): boolean => {
    if (!isCurrentRegionUserLoyaltyRegion || !!postPurchase) return false

    const transferBenefit = userBenefits?.find(benefit => benefit.code === 'airport_transfer')
    const hasTransferBenefit = !!transferBenefit && (transferBenefit.unlimited || !!transferBenefit.remaining)

    return airportCodes.length > 0 &&
      (hasTransferBenefit || isTasteOfGoldEligibleCheckout) &&
      isInternationalTrip
  },
)

export default getCanRedeemTransferLoyaltyBenefit
